module.exports = __webpack_public_path__ + "assets/img/icon-service1.82ba58ab.png";